// extracted by mini-css-extract-plugin
export var box = "Faq-module--box--3a033";
export var layout = "Faq-module--layout--7a6b5";
export var box_md = "Faq-module--box_md--1d4a7";
export var box_xmd = "Faq-module--box_xmd--77c24";
export var box_flex = "Faq-module--box_flex--7fa63";
export var box_lg = "Faq-module--box_lg--48f33";
export var box_sm = "Faq-module--box_sm--0986f";
export var box_outer = "Faq-module--box_outer--12749";
export var box_whiteBg = "Faq-module--box_white-bg--30842";
export var box_noMarginBottom = "Faq-module--box_no-margin-bottom--79627";
export var box_noPadding = "Faq-module--box_no-padding--f9fb5";
export var box_outerGray = "Faq-module--box_outer-gray--548e1";
export var box_dark = "Faq-module--box_dark--9e416";
export var box_zIndex = "Faq-module--box_z-index--25679";
export var box_zIndex6 = "Faq-module--box_z-index-6--a34d2";
export var box_eventsWithLine = "Faq-module--box_events-with-line--cd3c2";
export var box_featuresAo = "Faq-module--box_features-ao--148fc";
export var box_verticalPaddings = "Faq-module--box_vertical-paddings--baa5b";
export var clearP = "Faq-module--clearP--f5013";
export var clearP_vc = "Faq-module--clearP_vc--29848";
export var wrapper = "Faq-module--wrapper--5b70a";
export var description = "Faq-module--description--e1c03";
export var fadeInAnimation = "Faq-module--fadeInAnimation--aa5f0";
export var placeHolderShimmer = "Faq-module--placeHolderShimmer--937a9";